import { useConfirmDialog } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'
import React from 'react'
import { useTableContext } from '../Context'

export const ResetConfigButton = () => {
  const { onResetConfig } = useTableContext()
  const { onConfirm } = useConfirmDialog({
    title: 'Reset Configuration',
    text: 'This will reset the size, visibility and order of the current table layout. Do you wish to continue?',
    buttons: {
      confirm: {
        text: 'Yes, reset it!',
      },
    },

    confirmed: onResetConfig,
  })

  return <BusyButtonLink bsSize="sm" text="Reset Config" onClick={onConfirm} />
}
